import script from "./stepWidgetConf.vue?vue&type=script&setup=true&lang=ts"
export * from "./stepWidgetConf.vue?vue&type=script&setup=true&lang=ts"

import "./stepWidgetConf.vue?vue&type=style&index=0&id=16088135&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16088135"]])

export default __exports__